var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home-body"},[_c('topMenu',{on:{"setSave":_vm.setSave}}),_c('mainMenu'),_c('saveAs',{directives:[{name:"show",rawName:"v-show",value:(_vm.isSave),expression:"isSave"}],on:{"setSave":_vm.setSave}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }